var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settingsNotificationsSchedule" } }, [
    _c("div", { staticClass: "name" }, [_vm._v("Notification Schedule")]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "context" }, [
        _vm._v(
          "Select when you would like to receive notifications. You can choose to always receive notifications, or use your own customizable notification schedule."
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "type" },
        [
          _c("span", { staticClass: "type-name" }, [
            _vm._v("Push Notifications")
          ]),
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              staticClass: "bar float-right",
              attrs: { mandatory: "" },
              model: {
                value: _vm.togglePush,
                callback: function($$v) {
                  _vm.togglePush = $$v
                },
                expression: "togglePush"
              }
            },
            [
              _c(
                "v-btn",
                { staticClass: "option", attrs: { flat: "", value: "on" } },
                [_vm._v("\n          USE SCHEDULE\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { staticClass: "option", attrs: { flat: "", value: "off" } },
                [_vm._v("\n          ALWAYS ON\n        ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "type" },
        [
          _c("span", { staticClass: "type-name" }, [
            _vm._v("Email Notifications")
          ]),
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              staticClass: "bar float-right",
              attrs: { mandatory: "" },
              model: {
                value: _vm.toggleEmail,
                callback: function($$v) {
                  _vm.toggleEmail = $$v
                },
                expression: "toggleEmail"
              }
            },
            [
              _c(
                "v-btn",
                { staticClass: "option", attrs: { flat: "", value: "on" } },
                [_vm._v("\n          USE SCHEDULE\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { staticClass: "option", attrs: { flat: "", value: "off" } },
                [_vm._v("\n          ALWAYS ON\n        ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear" })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notification-schedule",
          class: { active: _vm.toggleEmail === "on" || _vm.togglePush === "on" }
        },
        [
          _c("div", { staticClass: "name smaller" }, [
            _vm._v("Custom Schedule")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "context" }, [
            _vm._v(
              "Select when you'd like to receive scheduled notifications. You will only receive notifications for events that occur within your schedule."
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.week, function(day, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "day",
                class: { schedule: day.type === "schedule" }
              },
              [
                _c("div", { staticClass: "day-name" }, [
                  _vm._v(_vm._s(day.name))
                ]),
                _vm._v(" "),
                _c(
                  "v-btn-toggle",
                  {
                    staticClass: "bar",
                    attrs: { mandatory: "" },
                    model: {
                      value: day.type,
                      callback: function($$v) {
                        _vm.$set(day, "type", $$v)
                      },
                      expression: "day.type"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "option",
                        attrs: { flat: "", value: "off" }
                      },
                      [_vm._v("\n            NONE\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "option",
                        attrs: { flat: "", value: "schedule" }
                      },
                      [_vm._v("\n            SCHEDULE\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "option",
                        attrs: { flat: "", value: "on" }
                      },
                      [_vm._v("\n            ALL DAY\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "inputs" }, [
                  day.slider
                    ? _c("div", { staticClass: "time" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.formatSliderTime(day.slider.get()[0]))
                          )
                        ]),
                        _vm._v(" to "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.formatSliderTime(day.slider.get()[1]))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    ref: key + "Slider",
                    refInFor: true,
                    staticClass: "slider"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clear" })
              ],
              1
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "v-btn",
          {
            attrs: { flat: "", color: "primary", loading: _vm.lockout },
            on: { click: _vm.save }
          },
          [_vm._v("Save")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clear" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5366f13c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5366f13c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsNotificationsSchedule.vue
// module id = 585
// module chunks = 4